// vim: ft=javascriptreact
import { useState } from 'react'
import {
  Button,
} from 'react-bootstrap'
import useAuth from '../hooks/useAuth'

const SignUpFormFacebook = () => {
  const {
    facebookSignin,
  } = useAuth()

  return (
    <Button variant="primary" size="lg" className="me-3" onClick={facebookSignin}>Sign Up With Facebook</Button>
  )

}

export default SignUpFormFacebook

